module.exports = __webpack_public_path__ + "static/wbh-c90f040ca1c34c9fb4198de8ad1415df.jpg";